module.exports = __webpack_public_path__ + "img/copy-icon.d2df5b19.svg";